import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { ServiceRequestOptions } from '@dealstack/frontend/shared/other/react/ApiWrapper/types';
import { Response } from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import {
	AuditTct,
	MipInvestorBankAccountDetailRes,
	ReviewBankAccountDto,
} from '@dealstack/shared/lib/generated';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';

export const getMipInvestorBankAccountDetail = async (
	args: { bankAccountId: string },
	options?: ServiceRequestOptions
) =>
	await makeRequest<Response<MipInvestorBankAccountDetailRes>>(
		{
			endpoint: formatUnicorn(API_PATHS.MIP_INVESTOR_BANK_ACCOUNT_ID_GET, {
				id: args.bankAccountId,
			}),
			method: HTTP_METHOD.GET,
		},
		{ ...options }
	);

export const reviewMipInvestorBankAccount = async (
	args: { bankAccountId: string; body: ReviewBankAccountDto },
	options?: ServiceRequestOptions
) =>
	await makeRequest<Response<MipInvestorBankAccountDetailRes>>(
		{
			endpoint: formatUnicorn(API_PATHS.MIP_INVESTOR_BANK_ACCOUNT_ID_REVIEW_POST, {
				id: args.bankAccountId,
			}),
			method: HTTP_METHOD.POST,
			body: JSON.stringify(args.body),
		},
		{ ...options }
	);

// Programme-scoped rather than the shared entity-audit route: that one filters on
// Audit.dealId, which is NULL for every programme account.
export const getMipInvestorBankAccountHistory = async (
	args: { bankAccountId: string },
	options?: ServiceRequestOptions
) =>
	await makeRequest<Response<AuditTct[]>>(
		{
			endpoint: formatUnicorn(API_PATHS.MIP_INVESTOR_BANK_ACCOUNT_ID_HISTORY_GET, {
				id: args.bankAccountId,
			}),
			method: HTTP_METHOD.GET,
		},
		{ ...options }
	);
